import { Box, Typography } from "@mui/material";

const steps = [
  "Submit Your CV",
  "Initial HR Screening",
  "Technical Interview",
  "Offer Release",
  "Onboarding & Training",
];

const brandBlue = "#1a237e";

const RecruitmentProcess = () => {
  return (
    <Box
      sx={{
        py: 10,
        px: { xs: 2, md: 6 },
        background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
        color: "#fff",
        position: "relative",
      }}
    >
      {/* Decorative blurred glow ball */}
      <Box
        sx={{
          position: "absolute",
          top: -80,
          left: -60,
          width: 180,
          height: 180,
          background: `${brandBlue}25`,
          borderRadius: "50%",
          filter: "blur(55px)",
        }}
      />

      <Typography
        variant="h4"
        fontWeight={800}
        align="center"
        sx={{
          mb: 4,
          fontSize: { xs: "1.8rem", md: "2.3rem" },
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Our Recruitment Process
      </Typography>

      {/* Flex Wrapper */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          flexWrap: "wrap",
          mt: 5,
        }}
      >
        {steps.map((step, index) => (
          <Box
            key={index}
            sx={{
              width: {
                xs: "100%",
                sm: "45%",
                md: "18%",
              },
              p: 3,
              borderRadius: "18px",
              background: "rgba(255,255,255,0.06)",
              backdropFilter: "blur(8px)",
              border: "1.5px solid rgba(255,255,255,0.12)",
              textAlign: "center",
              fontWeight: 600,
              position: "relative",
              boxShadow:
                "0 8px 25px rgba(0,0,0,0.4), inset 0 0 12px rgba(255,255,255,0.12)",
              transition: "all 0.35s ease",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow:
                  "0 12px 28px rgba(0,0,0,0.55), inset 0 0 20px rgba(255,255,255,0.15)",
                borderColor: `${brandBlue}CC`,
              },
            }}
          >
            {/* Step Number Badge */}
            <Box
              sx={{
                position: "absolute",
                top: -15,
                left: "50%",
                transform: "translateX(-50%)",
                width: 40,
                height: 40,
                borderRadius: "50%",
                background: `linear-gradient(135deg, ${brandBlue}, #3f51b5)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: "1rem",
                boxShadow: `0 6px 12px ${brandBlue}40`,
                color: "#fff",
              }}
            >
              {index + 1}
            </Box>

            <Typography
              sx={{
                mt: 3,
                fontSize: ".95rem",
                lineHeight: 1.4,
                color: "#cfd6ff",
              }}
            >
              {step}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RecruitmentProcess;
